import * as types from "../constants/ActionTypes";

const DEFAULT_COLOR = "#494b54";
const DEFAULT_ACCENT_COLOR = "#00779e";

const DEFAULT_LOGO_URL = "/images/logo_default@2x.png";

export const initialState = {
  primaryColor: DEFAULT_COLOR,
  accentColor: DEFAULT_ACCENT_COLOR,
  logoUrl: DEFAULT_LOGO_URL,
  loaded: undefined
};

function branding(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_BRANDING_RECEIVED:
      let primaryColor, accentColor, logoUrl;

      //new data structure coming from branding.json request
      if (action.data.common) {
        primaryColor = action.data.common.primary_color || DEFAULT_COLOR;
        accentColor = action.data.common.accent_color || DEFAULT_ACCENT_COLOR;
        //check for default logo is present in new navbar in react-components
        logoUrl = action.data.common.logo_url || DEFAULT_LOGO_URL;
      }
      //legacy data structure coming from /api/v3/custom_brand, can still be saved in users' localstorage, so keep it here for backward compatibility
      else {
        primaryColor = action.data.custom_color || DEFAULT_COLOR;
        accentColor = action.data.custom_accent_color || DEFAULT_ACCENT_COLOR;
        //check for default logo is present in new navbar in react-components
        logoUrl = action.data.logo || DEFAULT_LOGO_URL;
      }

      return {
        ...state,
        logoUrl,
        accentColor,
        primaryColor,
        loaded: true
      };

    case types.FETCH_BRANDING_ERROR:
      return {
        ...state,
        loaded: true
      };
    default:
      return state;
  }
}

export default branding;
